import deCountries from "../i18n/countries/countries-de.json";
import enCountries from "../i18n/countries/countries-en.json";
import esCountries from "../i18n/countries/countries-es.json";
import frCountries from "../i18n/countries/countries-fr.json";
import { useLocale } from "../i18n/hooks";

export function useCountriesOptions() {
  const locale = useLocale();
  const allCountries = {
    de: deCountries,
    en: enCountries,
    es: esCountries,
    fr: frCountries,
  };

  const countries = allCountries[locale];

  const countriesOptions = Object.entries(countries).map(
    ([country, countryName], idx) => (
      <option value={country} key={`${country}-${idx}`}>
        {countryName}
      </option>
    )
  );
  return countriesOptions;
}
